export const QUERY_KEYS = {
  faceIdProfile: (profileId: string) => ['faceIdProfile', profileId],
  profileThumbnail: (profileId: string) => ['profileThumbnail', profileId],
  profilesSearching: (payload: object) => ['profilesSearching', payload],
  devicesSearching: (payload: object) => ['devicesSearching', payload],
  checkInLogsSearching: (payload: object) => ['checkInLogsSearching', payload],
  roleAssignmentsSearching: (payload: object) => ['roleAssignmentsSearching', payload],
  ipadConfig: (ipadId: string) => ['ipadConfig', ipadId],
  roleAssignment: (id: string) => ['roleAssignment', id],
  checkInLogDetails: (logId: string) => ['checkInLogDetails', logId],
  roles: ['roles'],
  faceIdProfileFacial: (profileId: string) => ['faceIdProfileFacial', profileId],
  currentProfile: ['currentProfile'],
};
